import { QuoteWrapper } from '../../models/quote/quote-wrapper';
import { TranslateService } from '@ngx-translate/core';
import {CmcQuote} from "../../models/quote/cmc-quote";

export abstract class CmcProtocolService {

    constructor(protected translateService: TranslateService) {
    }

    abstract searchProtocols(countryIsoCode: string, userRole: string, pageable: Map<string, string>, searchParam: string);

    abstract getCmcProtocol(cmcCode: string, countryIsoCode: string, role: string);

    getCmcLabel(quoteWrapper: QuoteWrapper) {
        return quoteWrapper instanceof CmcQuote ? this.translateService.instant('LABEL_CMC') + ' ' + quoteWrapper.cmcProtocolCode + ' - ' + quoteWrapper.cmcProtocolName : null;
    }





}
